"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactIntl = require("react-intl");

var _default = (0, _reactIntl.defineMessages)({
  requiredRaces: {
    id: "tooltip.item.attrTable.requiredRaces",
    defaultMessage: "Acceptable Races",
    description: "Acceptable Races"
  },
  requiredGender: {
    id: "tooltip.item.attrTable.requiredGender",
    defaultMessage: "Acceptable Genders",
    description: "Acceptable Genders"
  },
  requiredGenderAny: {
    id: "tooltip.item.attrTable.requiredGender.any",
    defaultMessage: "Any",
    description: "Any"
  },
  requiredGenderMale: {
    id: "tooltip.item.attrTable.requiredGender.male",
    defaultMessage: "Male only",
    description: "Male only"
  },
  requiredGenderFemale: {
    id: "tooltip.item.attrTable.requiredGender.female",
    defaultMessage: "Female only",
    description: "Female only"
  },
  requiredClasses: {
    id: "tooltip.item.attrTable.requiredClasses",
    defaultMessage: "Acceptable Classes",
    description: "Acceptable Classes"
  },
  requiredLevel: {
    id: "tooltip.item.attrTable.requiredLevel",
    defaultMessage: "Requirement Level",
    description: "Requirement Level"
  },
  requiredMats: {
    id: "tooltip.item.attrTable.requiredMats",
    defaultMessage: "Necessity Material",
    description: "Necessity Material"
  },
  requiredSkills: {
    id: "tooltip.item.attrTable.requiredSkills",
    defaultMessage: "Necessity Skills",
    description: "Necessity Skills"
  },
  requiredStrength: {
    id: "tooltip.item.attrTable.requiredStrength",
    defaultMessage: "Acceptable STR",
    description: "Acceptable STR"
  },
  requiredIntelligence: {
    id: "tooltip.item.attrTable.requiredIntelligence",
    defaultMessage: "Acceptable INT",
    description: "Acceptable INT"
  },
  requiredDexterity: {
    id: "tooltip.item.attrTable.requiredDexterity",
    defaultMessage: "Acceptable DEX",
    description: "Acceptable DEX"
  },
  durability: {
    id: "tooltip.item.attrTable.durability",
    defaultMessage: "Durability",
    description: "Durability"
  },
  phyAttack: {
    id: "tooltip.item.attrTable.phyAttack",
    defaultMessage: "Physical Offense",
    description: "Physical Offense"
  },
  magAttack: {
    id: "tooltip.item.attrTable.magAttack",
    defaultMessage: "Magical Offense",
    description: "Magical Offense"
  },
  phyDefense: {
    id: "tooltip.item.attrTable.phyDefense",
    defaultMessage: "Physical Defense",
    description: "Physical Defense"
  },
  magDefense: {
    id: "tooltip.item.attrTable.magDefense",
    defaultMessage: "Magical Defense",
    description: "Magical Defense"
  },
  manaBonus: {
    id: "tooltip.item.attrTable.manaBonus",
    defaultMessage: "Mana Bonus",
    description: "Mana Bonus"
  },
  castingTimeDecrement: {
    id: "tooltip.item.attrTable.castingTimeDecrement",
    defaultMessage: "Casting Time Decrement",
    description: "Casting Time Decrement"
  },
  avoidanceTimeDecrement: {
    id: "tooltip.item.attrTable.avoidanceTimeDecrement",
    defaultMessage: "Avoidance Time Decrement",
    description: "Avoidance Time Decrement"
  },
  attackSpeed: {
    id: "tooltip.item.attrTable.attackSpeed",
    defaultMessage: "Attack Speed",
    description: "Attack Speed"
  }
});

exports.default = _default;